const convertDataLayerPayload = ({
  id,
  brokerIds,
  builders,
  brokerNames,
  currency,
  listingType,
  listName,
  name,
  price,
  primaryCategory,
  promotionType
}) => {
  const response = {
    ecommerce_brand: builders,
    ecommerce_broker_name: brokerNames,
    ecommerce_broker_sku: brokerIds,
    ecommerce_category: primaryCategory,
    ecommerce_currency: currency,
    ecommerce_listing_name: name,
    ecommerce_listing_type: listingType,
    ecommerce_listing_sku: id,
    ecommerce_price: price,
    ecommerce_promotion_type: promotionType
  };

  if (listName) {
    return { ...response, ecommerce_list: listName };
  }

  return response;
};

export default convertDataLayerPayload;
